import React from 'react';
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import Cache from '@aws-amplify/cache';
import { toast } from 'react-toastify';

export class Onboarding extends React.Component {

  constructor(props)  {
      super(props);
      this.handleChange = this.handleChange.bind(this);
  }

  state = {
      photo: '',
      invoicePeriod: '4',
      cutOffDays: '1',
      cutOffTime: '14',
      statusView: 'Logo',
      enableAutoInvoice: true,
      enableOrderReminders: true
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  setupUser = async () => {
      let newSettings = {}
      newSettings.invoicePeriod = this.state.invoicePeriod
      newSettings.cutOffDays = this.state.cutOffDays
      newSettings.cutOffTime = this.state.cutOffTime
      newSettings.enableAutoInvoice = this.state.enableAutoInvoice
      newSettings.enableOrderReminders = this.state.enableOrderReminders
      newSettings.defaultDeliveryDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]
      newSettings.integration = {}
      newSettings.paymentTerms = {option: 'CashOnDelivery', value: ''}
      newSettings.minOrderValue = 100
      newSettings.holidays = []
      newSettings.orderCutOffExcludeWeekends = false
      newSettings.defaultCatalogue = null
      newSettings.defaultPriceList = null
      newSettings.reminderTime1 = 4
      newSettings.reminderTime2 = 2
      newSettings.invoiceWeeklySummaryEnabled = false
      newSettings.enableNotifications = false
      let requestParams = {
        'settings': newSettings,
        'photo': this.state.photo
      }
      axios.post('/user/onboarding', requestParams)
          .then(data => {
              console.log(data);
              window.location.reload()
          })
          .catch(err => {
            console.log(err)
            Rollbar.error(err)
          })
  }

  uploadImage = e => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      let requestParams = {
        'fileName': 'profile_' + this.props.user.supplierID + '_' + file.name,
        'fileType': file.type
      }
      axios.post('/user/update/image', requestParams)
          .then(data => {
            console.log(data);
            const options = {
              headers: {
                'Content-Type': file.type,
              }
            };
            axios.defaults.headers.common = {}
            axios.put(data.url, file, options)
              .then(data2 => {
                console.log(data2);
                this.setState({
                  photo: data.finalUrl
                });
              })
              .catch (err2 => {
                console.log(err2);
                Rollbar.error(err2)
                toast.error("Error: Could not upload image");
              })
              .then(() => {
                axios.defaults.headers.common = {'Authorization': 'Bearer ' + Cache.getItem('supplier_auth_token')}
              })
          })
          .catch (err => {
            console.log(err);
            Rollbar.error(err)
            toast.error("Error: Could not get s3 upload url");
          })
    }
  }

    render() {
        return (
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center onboarding-logo-section">
                <img src="/logo.png" alt="logo" width="28%"/>
                <h4>Get Started</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {this.state.statusView === 'Logo' ? (
                <div className="modal-dialog allow-click">
                  <div className="modal-content">
                    <div className="modal-header text-center">
                      <h4 className="modal-title ">Company Logo</h4>
                    </div>
                    <div className="modal-body text-center">
                      <div className="form-group productImg">
                        <div className="custom-file mb-2">
                          <input type="file" className="custom-file-input" id="customFile" accept='image/*' onChange={this.uploadImage}/>
                          <label className="custom-file-label" for="customFile">Choose file</label>
                        </div>
                        {this.state.photo ? <img src={this.state.photo} alt="profile logo" /> : <p>Please upload a company logo</p>}
                      </div>
                    </div>
                  </div>
                  <div className="row pad-top">
                    <div className="col-md-6 text-left"><button type="button" className="btn btn-primary disabled">Previous</button></div>
                    <div className="col-md-6 text-right"><button type="button" className={this.state.photo ? "btn btn-primary" : "btn btn-primary disabled"} onClick={() => this.setState({ statusView: 'Settings' })} >Next</button></div>
                  </div>
                </div>) : null }
                {this.state.statusView === 'Settings' ? (
                <div className="modal-dialog allow-click">
                  <div className="modal-content">
                    <div className="modal-header text-center">
                      <h4 className="modal-title ">Settings</h4>
                    </div>
                    <div className="modal-body">
                      {/* <div className="form-group">
                        <label>Payment Period (Days):</label>
                        <input type="text" className="form-control" value={this.state.paymentPeriod} onChange={this.handleChange} name="paymentPeriod" />
                        <small className="form-text text-muted">
                          When the payment is due, e.g. 14 days after the order is placed.
                        </small>
                      </div> */}
                      <div className="form-group">
                        <label>Invoice Period (Days):</label>
                        <input type="text" className="form-control" value={this.state.invoicePeriod} onChange={this.handleChange} name="invoicePeriod" />
                        <small className="form-text text-muted">
                          When the system should send out the invoice. Set this value to 0 to have the invoice be sent out immediately after an order is placed.
                        </small>
                      </div>
                      <div className="form-group">
                        <label>Order cut off days:</label>
                        <input type="text" className="form-control" value={this.state.cutOffDays} onChange={this.handleChange} name="cutOffDays" />
                        <small className="form-text text-muted">
                          The number of days before the cut off time to place an order is reached. E.g. 2 days. Customer places order on Monday for a Wednesday delivery.
                        </small>
                      </div>
                      <div className="form-group">
                        <label>Order cut off time (24hr):</label>
                        <input type="text" className="form-control" value={this.state.cutOffTime} onChange={this.handleChange} name="cutOffTime" />
                        <small className="form-text text-muted">
                          Used in conjunction with the above cut off days. E.g. before 2:00pm on Monday.
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="row pad-top">
                    <div className="col-md-6 text-left"><button type="button" className="btn btn-primary" onClick={() => this.setState({ statusView: 'Logo' })} >Previous</button></div>
                    <div className="col-md-6 text-right"><button type="button" className="btn btn-primary" onClick={this.setupUser}>Finish</button></div>
                  </div>
                </div>) : null }
              </div>
            </div>
          </div>
        );
    }
}
